import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";

@Component({
    selector: "search-select",
    templateUrl: "./search-select.component.html",
    styleUrls: ["./search-select.component.scss"],
})
export class SearchSelectComponent implements OnInit, OnChanges {

    @Input() public prefix: string = "search-select";
    @Input() public classes: string = "";
    @Input() public items: any[] = [];
    @Input() public selected: any;
    @Input() public placeholder: any;
    @Input() public prop: string = "key";
    @Input() public simpleList: boolean = false;
    @Input() public showAdd: boolean = false;
    @Input() public showEdit: boolean = false;
    @Input() public hideSelected: boolean = false;
    @Input() public noForm; public boolean = false;
    @Output() public change: EventEmitter<any> = new EventEmitter();
    @Output() public editFunction: EventEmitter<any> = new EventEmitter();
    @Output() public addFunction: EventEmitter<any> = new EventEmitter();

    public _selected: any = { label: "", [this.prop]: "" };
    public isOpen: boolean = false;
    public filter: any = !this.simpleList ? { searchFilter: "" } : "";
    public sep: string = " -- ";

    public ngOnInit() {
        if (this.items) {
            const el = document.createElement('div');
            if (!this.simpleList) {
                this.items.forEach((item: any) => {
                  el.innerHTML = (item.fullName ? item.fullName : (item.name ? item.name : (item.label ? item.label : item.value)));
                    item.searchFilter = el.textContent || el.innerText || el.innerHTML;
                });
            }
            if (this.selected) {
                const tempSelected: any = this.items.find((item: any) => {
                    // eslint-disable-next-line
                    return (item[this.prop] ? item[this.prop] : (item.id ? item.id : item)) === this.selected;
                });
                if (tempSelected) {
                  el.innerHTML = (tempSelected.fullName ? tempSelected.fullName : (tempSelected.name ? tempSelected.name : (tempSelected.label ? tempSelected.label : tempSelected.value)));
                    this._selected.label = el.textContent || el.innerText || el.innerHTML;
                    // eslint-disable-next-line
                    this._selected[this.prop] = tempSelected[this.prop] ? tempSelected[this.prop] : (tempSelected.id ? tempSelected.id : tempSelected);
                }
            }
            this.filter = !this.simpleList ? { searchFilter: "" } : "";
        }
        // console.log(this.selected, this._selected);
    }

    public ngOnChanges(_changes: SimpleChanges): void {
        if (this.items) {
            if (!this.simpleList) {
                this.items.forEach((item: any) => {
                    item.searchFilter = (item.fullName ? item.fullName : (item.name ? item.name : (item.label ? item.label : item.value)));
                });
            }
            if (this.selected) {
                const tempSelected: any = this.items.find((item: any) => {
                    // console.log(this.selected, item);
                    // eslint-disable-next-line
                    // console.log("--- search-select check:", item[this.prop], this.selected, this.prop);
                    return (item[this.prop] ? item[this.prop] : item) === this.selected;
                });
                console.log("--- search-select tempSelected:", tempSelected, "selected:", this.selected, "prop:", this.prop);
                if (tempSelected) {
                    this._selected.label = this.htmlToText(tempSelected.fullName ? tempSelected.fullName : (tempSelected.name ? tempSelected.name : (tempSelected.label ? tempSelected.label : tempSelected.value)));
                    // eslint-disable-next-line
                    this._selected[this.prop] = tempSelected[this.prop] ? tempSelected[this.prop] : (tempSelected.id ? tempSelected.id : tempSelected);
                } else {
                    this._selected = {};
                    this._selected.label = "";
                    // eslint-disable-next-line
                    this._selected[this.prop] = "";
                }
            } else {
                this._selected = {};
                this._selected.label = "";
                // eslint-disable-next-line
                this._selected[this.prop] = "";
            }
        }
        // console.log(_changes, this.selected, this._selected);
    }

    public selectItem(item): void {
        this.selected = item;
        this._selected.label = this.htmlToText((item.fullName ? item.fullName : (item.name ? item.name : (item.label ? item.label : item.value))));
        // eslint-disable-next-line
        this._selected[this.prop] = item[this.prop] ? item[this.prop] : (item.id ? item.id : item);
        // eslint-disable-next-line
        // console.log(item, this._selected, this.prop);
        this.change.emit(this._selected[this.prop]);
        this.clearFilter();
        this.unfocusInput();
    }

    public handleClick(event): void {
        if (event.target.id !== this.prefix && this.isOpen) {
            this.unfocusInput();
            this.clearFilter();
        }
    }

    public resetSelectSearch() {
        if (this.isOpen) {
            this.filter = !this.simpleList ? { searchFilter: "" } : "";
        } else {
            this._selected = {};
            this._selected.label = "";
            // eslint-disable-next-line
            this._selected[this.prop] = "";
        }
        this.change.emit(null);
    }

    public focusInput(): void {
        this.isOpen = true;
    }

    public unfocusInput(): void {
        this.isOpen = false;
    }

    public clearFilter(): void {
        this.filter = !this.simpleList ? { searchFilter: "" } : "";
    }

    public filterChanged(value: any): void {
        // filter inputs
        this.filter = !this.simpleList ? { searchFilter: value } : value;
    }

    htmlToText(html: string): string {
      const el = document.createElement('div');
      el.innerHTML = html ?? '';
      return el.textContent ?? '';
    }

  onFilterChange(value: string): void {
    if (this.simpleList) {
      this.filter = value;
    } else {
      this.filter = this.filter ?? { searchFilter: "" };
      this.filter.searchFilter = value;
    }
  }

  onOptionSelected(item: any): void {
    this.selectItem(item);
  }

  hasValueToClear(): boolean {
    const hasFilter =
      !!this.filter &&
      (this.simpleList ? (this.filter as string).length > 0 : (this.filter.searchFilter?.length ?? 0) > 0);

    const sel = this._selected as any;
    const hasSelected = !!sel && ((sel.prop?.length ?? 0) > 0 || (sel.label?.length ?? 0) > 0);

    return hasFilter || hasSelected;
  }
}
